module.exports = __webpack_public_path__ + "static/media/4@2x.af13b3c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/4@2x.png
// module id = 1562
// module chunks = 0